// src/components/KeyMetricsSection.js
import React from 'react';
import { Card, Typography, Box, Grid } from '@mui/material';
import { FaMapMarkedAlt, FaLanguage, FaAward, FaDollarSign, FaHome } from 'react-icons/fa';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const KeyMetricsSection = () => {
  const metrics = [
    {
      icon: <FaDollarSign size={60} color="#2e7d32" />,
      label: 'Avg. Home Price',
      end: 350,
      prefix: '$',
      suffix: 'K+',
      color: '#2e7d32',
    },
    {
      icon: <FaMapMarkedAlt size={60} color="#1d43b5" />,
      label: 'Markets Served',
      end: 4,
      suffix: '',
      color: '#1d43b5',
    },
    {
      icon: <FaLanguage size={60} color="#ff7300" />,
      label: 'Languages Spoken',
      end: 4,
      suffix: '',
      color: '#ff7300',
    },
    {
      icon: <FaAward size={60} color="#82ca9d" />,
      label: 'Top Performer Awards',
      end: 2,
      suffix: '',
      color: '#82ca9d',
    },
    {
      icon: <FaHome size={60} color="#8b4513" />,
      label: 'Property Types',
      end: 5,
      suffix: '+',
      color: '#8b4513',
      description: 'Custom Homes, Luxury, Farms & More',
    },
  ];

  return (
    <Box
      sx={{
        padding: '40px 20px',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Typography
        variant="h4"
        component="h2"
        gutterBottom
        sx={{
          color: '#333333',
          textAlign: 'center',
          marginBottom: '40px',
        }}
      >
        At a Glance
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {metrics.map((metric, index) => (
          <MetricCard
            key={metric.label}
            {...metric}
            delay={index * 0.5} // Optional delay for staggered animations
          />
        ))}
      </Grid>
    </Box>
  );
};

const MetricCard = ({
  icon,
  label,
  end,
  prefix,
  suffix,
  separator,
  color,
  description,
  delay = 0,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.3,
  });

  return (
    <Grid item xs={6} sm={4} md={2.4}>
      <Card
        ref={ref}
        sx={{
          padding: '20px',
          textAlign: 'center',
          transition: 'transform 0.3s',
          minHeight: '220px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          paddingTop: '30px',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
        aria-label={label}
      >
        <Box sx={{ height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {icon}
        </Box>
        <Typography variant="h6" component="h4" sx={{ marginTop: '15px', fontSize: '0.95rem' }}>
          {label}
        </Typography>
        <Typography
          variant="h3"
          component="p"
          sx={{ color: color, marginTop: '10px', fontSize: '2rem' }}
        >
          <CountUp
            start={inView ? null : 0}
            end={inView ? end : 0}
            duration={2}
            prefix={prefix}
            suffix={suffix}
            separator={separator}
            useEasing
          >
            {({ countUpRef, start }) => {
              if (inView) {
                setTimeout(() => {
                  start();
                }, delay * 1000);
              }
              return <span ref={countUpRef} />;
            }}
          </CountUp>
        </Typography>
        {description && (
          <Typography variant="caption" sx={{ marginTop: '8px', color: '#666', fontSize: '0.7rem' }}>
            {description}
          </Typography>
        )}
      </Card>
    </Grid>
  );
};

export default KeyMetricsSection;
